exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qty-dec-btn[data-v-db556938],.qty-inc-btn[data-v-db556938]{display:inline-flex;line-height:14px;align-items:center;justify-content:center}.input-group[data-v-db556938]{max-width:85px;display:inline-table}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-db556938","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ixcms/themes/src/vue-src/base/_base-number-input.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"optionsId":"0","vue":true,"id":"data-v-db556938","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ixcms/themes/src/vue-src/base/_base-number-input.vue
// module chunks = 24